import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistraturaOnlineComponent } from './registratura-online.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ToastrModule } from 'ngx-toastr';
import { NgxLoadingModule } from 'ngx-loading';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';

import { RegistraturaOnlineRoutingModule } from './registratura-online-routing.module'
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@NgModule({
    declarations: [
        RegistraturaOnlineComponent
    ],
    imports: [
        CommonModule,
        RegistraturaOnlineRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        ToastrModule,
        NgxLoadingModule,
        MatAutocompleteModule,
        MatButtonModule
    ]
})
export class RegistraturaOnlineModule { }
